import { useState, useCallback } from 'react';
import { 
  getDescriptionData, 
  getSubcategoryData, 
  getParentSubcategoryData,
} from '../utils/dataHelpers';

const useChartData = (initialData, mode) => {
  const [selectedSubcategory, setSelectedSubcategory] = useState(null);
  const [descriptionData, setDescriptionData] = useState(null);

  const handleSelection = useCallback((selection) => {
    if (!selection) {
      setSelectedSubcategory(null);
      setDescriptionData(null);
      return;
    }

    // Prepare description data with required fields
    const descData = {
      ...selection,
      title: selection.name,
      description: selection.description,
      segmentType: selection.segmentType,
      id: selection.segmentId || selection.id, // Use segmentId for leaves, fallback to id
    };

    setSelectedSubcategory(selection);
    setDescriptionData(descData);
  }, [mode]);

  const handleBack = useCallback(() => {
    // find parent
    const parentSubcategory = getParentSubcategoryData(initialData, selectedSubcategory);

    if (parentSubcategory) {
      if (initialData.id == parentSubcategory.id){
        setSelectedSubcategory(null);
        setDescriptionData(null);
      } else {
          setSelectedSubcategory(parentSubcategory);
          setDescriptionData(getDescriptionData(initialData, parentSubcategory));
      }
    } else {
      setSelectedSubcategory(null);
      setDescriptionData(null);
    }

  }, [selectedSubcategory]);


  const getCurrentData = useCallback(() => {
    if (selectedSubcategory) {
        return getSubcategoryData(initialData, selectedSubcategory);
    }
    return initialData;

  }, [initialData, selectedSubcategory]);

  return {
    selectedSubcategory,
    descriptionData,
    handleSelection,
    handleBack,
    getCurrentData,
  };
};

export default useChartData; 
